import { lazy } from "react";

// Caricamento a richiesta delle pagine (code splitting). Dopo una nuova
// pubblicazione i file con hash del vecchio build non esistono piu': una scheda
// rimasta aperta, navigando, non riuscirebbe a scaricare la pagina e
// resterebbe bianca. In quel caso si ricarica UNA volta l'app (prende l'index
// nuovo); se fallisce di nuovo l'errore e' reale (rete assente) e si propaga.
// Il flag vive in sessionStorage (solo tecnico, sparisce con la scheda) e si
// azzera al primo caricamento riuscito.
export const CHUNK_RELOAD_KEY = "aiposto:chunk-reload";

export function lazyPage(factory) {
  // Una sola richiesta del file per pagina, anche se `preload()` e il primo
  // rendering la chiedono insieme. Un preload fallito NON conta come errore di
  // pagina (niente ricarica automatica, niente flag): si dimentica e il
  // rendering riprova da zero se e quando la pagina serve davvero.
  let pending = null;
  const load = () => (pending ||= factory());
  const Page = lazy(() =>
    load().then(
      (mod) => {
        try { window.sessionStorage.removeItem(CHUNK_RELOAD_KEY); } catch { /* storage bloccato */ }
        return mod;
      },
      (err) => {
        pending = null;
        let alreadyReloaded = true;
        try {
          alreadyReloaded = window.sessionStorage.getItem(CHUNK_RELOAD_KEY) === "1";
          if (!alreadyReloaded) window.sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
        } catch { /* storage bloccato: niente ricarica automatica, niente cicli */ }
        if (alreadyReloaded) throw err;
        window.location.reload();
        return new Promise(() => {}); // la pagina si sta ricaricando
      },
    ),
  );
  // Scarica il file in anticipo (es. in parallelo a una richiesta che precede il
  // rendering della pagina), senza renderizzare nulla.
  Page.preload = () => {
    load().catch(() => { pending = null; });
  };
  return Page;
}
